import { createSlice } from '@reduxjs/toolkit';
import { calculateAllUserRoles } from '../../lib';
import { resetApplication } from '../application/slice';
import userState from './state';
export const userSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => userState);
    },
    initialState: userState,
    name: 'user',
    reducers: {
        errorReceiveCurrentUser: state => {
            state.requestingCurrentUser = false;
        },
        failedReceiveCurrentUser: state => {
            state.requestingCurrentUser = false;
        },
        failedReceiveUserLocation: {
            prepare: positionError => {
                return {
                    payload: {
                        positionError
                    }
                };
            },
            reducer: (state, action) => {
                const { positionError } = action.payload;
                state.positionError = positionError;
                state.requestingUserLocation = false;
            }
        },
        receiveCurrentUser: {
            prepare: (currentUser, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        currentUser
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, currentUser } = action.payload;
                if (consumerAPI) {
                    const { email, last_login, image, memberships } = currentUser;
                    const allUserRoles = calculateAllUserRoles(memberships, true);
                    state.allUserRoles = allUserRoles;
                    state.email = email;
                    state.last_login = last_login;
                    state.picture = image;
                }
                else {
                    const { email, last_login, picture, memberships } = currentUser;
                    const allUserRoles = calculateAllUserRoles(memberships, false);
                    state.allUserRoles = allUserRoles;
                    state.email = email;
                    state.last_login = last_login;
                    state.picture = picture;
                }
                state.requestingCurrentUser = false;
            }
        },
        receiveUserLocation: {
            prepare: userLocation => {
                return {
                    payload: {
                        userLocation
                    }
                };
            },
            reducer: (state, action) => {
                const { userLocation } = action.payload;
                state.userLocation = userLocation;
                state.requestingUserLocation = false;
            }
        },
        requestCurrentUser: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingCurrentUser = true;
            }
        },
        requestUserLocation: state => {
            state.requestingUserLocation = true;
        },
        resetUser: () => userState,
        resetUserLocation: state => {
            state.userLocation = undefined;
        },
        setUserRoles: {
            prepare: userRoles => {
                return {
                    payload: {
                        userRoles
                    }
                };
            },
            reducer: (state, action) => {
                const { userRoles } = action.payload;
                return Object.assign(Object.assign({}, state), userRoles);
            }
        }
    }
});
export const { errorReceiveCurrentUser, failedReceiveCurrentUser, failedReceiveUserLocation, receiveCurrentUser, receiveUserLocation, requestCurrentUser, requestUserLocation, resetUser, resetUserLocation, setUserRoles } = userSlice.actions;
export default userSlice.reducer;
